import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import './ActiveList.css';
import { ServicegetCommunicationv1, ServiceResendSMS } from "../Services/Service";
import DataTable from './DataTable/DataTableV1';
import { CustomLoader } from "../Services/CommonLibrary";
import { Modal, Button } from "react-bootstrap";
import moment from 'moment';

function CommunicationTextV1() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedEncId, setSelectedEncId] = useState('');

    const handleClose = () => setShowModal(false);
    const accessFrom = localStorage.getItem('access');
    const dropStatus = [
        { value: 'onboarded', label: 'Onboarded' },
        { value: 'reminder1', label: 'Reminder 1' },
        { value: 'reminder2', label: 'Reminder 2' },
        { value: 'reminder3', label: 'Reminder 3' },
    ];

    const [queryParams, setQueryParams] = useState({
        clear: false,
        page: 1,
        pageSize: 50,
        sortField: '',
        sortDirection: '',
        search: '',
        filterData: {
            statusFilter: 'onboarded',
            dateStartFilter: '',
            dateEndFilter: ''
        }
    });

    const statusOptions = [
        { value: 'onboarded', label: 'Onboarded' },
        { value: 'reminder1', label: 'Reminder 1' },
        { value: 'reminder2', label: 'Reminder 2' },
        { value: 'reminder3', label: 'Reminder 3' }
    ];

    useEffect(() => {
        fetchCommunicationText(queryParams);
    }, [queryParams]);

    function formatDate(inputDate) {
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    const fetchCommunicationText = async (params) => {
        const PostData = {
            status: params.filterData?.statusFilter || 'onboarded',
            page: params.page,
            pageSize: params.pageSize,
            sortField: params.sortField,
            dateStart: params.filterData?.smsStartFilter ? formatDate(params.filterData?.smsStartFilter) : "",
            dateEnd: params.filterData?.smsEndFilter ? formatDate(params.filterData?.smsEndFilter) : "",
            sortDirection: params.sortDirection,
            search: params.search
        };
        console.log("PostData", PostData);
        setLoading(true);
        try {
            const response = await ServicegetCommunicationv1(PostData);
            setData(response.data.data.communicationlist);
            setTotalRows(Number(response.data.data.total));
        } catch (error) {
            console.error('Error fetching communication text:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleResendSMS = async () => {
        setLoading(true);
        try {
            await ServiceResendSMS(selectedEncId);
            await fetchCommunicationText(queryParams);
            setSelectedEncId('');
            handleClose();
        } catch (error) {
            console.error('Error resending SMS:', error);
        } finally {
            setLoading(false);
        }
    };

    const viewPopup = (enc_id) => {
        setSelectedEncId(enc_id);
        setShowModal(true);
    };

    const handlePageChange = useCallback((page, pageSize) => {
        setQueryParams(prev => ({
            ...prev,
            page: page + 1,
            pageSize
        }));
    }, []);

    const handleFilterChange = useCallback((filterData) => {
        setQueryParams(prev => ({
            ...prev,
            filterData: { ...prev.filterData, ...filterData },
            page: 1
        }));
    }, []);

    const handleSortChange = ({ field, direction }) => {
        setQueryParams(prev => ({
            ...prev,
            sortField: field,
            sortDirection: direction
        }));
    };

    const handleSearchChange = (searchTerm) => {
        setQueryParams(prev => ({
            ...prev,
            search: searchTerm,
            page: 1
        }));
    };

    const handlePageSizeChange = (newPageSize) => {
        setQueryParams(prev => ({
            ...prev,
            pageSize: newPageSize
        }));
    };

    const columnsV1 = useMemo(() => [
        { field: 'mobile', label: 'Mobile' },
        { field: 'smsText', label: 'SMS Text' },
        { field: 'status', label: 'Status' },
        { field: 'createdTime', label: 'Sent Date' }
    ], []);

    const extraColumns = useMemo(() => [
        {
            field: 'action',
            label: 'Action',
            button: true,
            omit: accessFrom !== 'superadmin' && accessFrom !== 'admin',
            content: row => {
                return (accessFrom === 'superadmin' || accessFrom === 'admin') ? (
                    <button
                        className='btn btn-primary btn-sm'
                        onClick={() => viewPopup(row.enc_id)}
                    >
                        Resend
                    </button>
                ) : null;
            }
        }
    ], [accessFrom]);
    const onValueChange = (e) => {

        if (e.target.id == 'filterStatus') {
            setLoading(true);
            // fetchProgramDetails(e.target.value);
            setQueryParams(prev => ({
                ...prev,
                filterData: { ...prev.filterData, statusFilter: e.target.value },
                page: 1
            }));
        }

    }

    const updateColumnConditions = useMemo(() => [
        {
            condition: (column, row) => column.field === "smsText",
            content: row => (
                <div className="tdData text-wrap" style={{ whiteSpace: 'pre-wrap' }}>
                    {row.smsText}
                </div>
            )
        },
        {
            condition: (column, row) => column.field === "status",
            content: row => (
                <div className="tdData" style={{
                    color: row.status.toLowerCase() === 'delivered' ? 'green' : 'red',
                    textTransform: 'capitalize'
                }}>
                    {row.status}
                </div>
            )
        },
        {
            condition: (column, row) => column.field === "createdTime",
            content: row => (
                <div className="tdData">
                    {moment(row.createdTime).format('DD MMM YYYY hh:mm A')}
                </div>
            )
        }
    ], []);

    return (
        <section className="">
            <div className="row">
                <div className="col-md-3">
                    <div className="form-floating">
                        <p htmlFor="filterStatus" style={{ display: "flex" }}>Filter Status:</p>
                        <select className="form-control" style={{ "height": "36px", "padding": "0 0 0 25px" }} required name="filterStatus" id="filterStatus" onChange={(e) => onValueChange(e)} >
                            {dropStatus.map((dropStatus, i) => (
                                <option value={dropStatus.value} key={i}>{dropStatus.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="FL">
                    <div className="table-responsive">
                        <DataTable
                            columns={columnsV1}
                            data={data}
                            totalRows={totalRows}
                            loading={loading}
                            csvName="Communication_Text"
                            exportCSVValue={true}
                            title="Communication Text"
                            onPageSizeChange={handlePageSizeChange}
                            onPageChange={handlePageChange}
                            onSortChange={handleSortChange}
                            onSearchChange={handleSearchChange}
                            onFilterChange={handleFilterChange}
                            defaultPageSize={50}
                            pageSizeOptions={[25, 50, 100, 200]}
                            extraColumns={extraColumns}
                            updateColumnConditions={updateColumnConditions}
                            filterStatusOptions={statusOptions}
                            filterSmsDate={true}
                            showClearbtn={true}
                            showFilter={true}
                        />
                    </div>
                </div>
            </div>

            {loading && <CustomLoader />}

            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Resend SMS</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to resend this SMS?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                    <Button variant="primary" onClick={handleResendSMS}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
}

export default CommunicationTextV1;